import {List} from "immutable";
import Term, {isEOF, isBindingIdentifier, isFunctionDeclaration, isFunctionExpression, isFunctionTerm, isFunctionWithName, isSyntaxDeclaration, isVariableDeclaration, isVariableDeclarationStatement, isImport, isExport} from "./terms";
import {Scope, freshScope} from "./scope";
import ApplyScopeInParamsReducer from "./apply-scope-in-params-reducer";
import reducer, {MonoidalReducer} from "shift-reducer";
import Expander from "./expander";
import Syntax from "./syntax";
import {serializer, makeDeserializer} from "./serializer";
import {enforestExpr, Enforester} from "./enforester";
import {assert} from "./errors";
import {processTemplate} from "./template-processor.js";
export default class TermExpander {
  constructor(context_733) {
    this.context = context_733;
  }
  expand(term_734) {
    let field_735 = "expand" + term_734.type;
    if (typeof this[field_735] === "function") {
      return this[field_735](term_734);
    }
    assert(false, "expand not implemented yet for: " + term_734.type);
  }
  expandTemplateExpression(term_736) {
    return new Term("TemplateExpression", {tag: term_736.tag == null ? null : this.expand(term_736.tag), elements: term_736.elements.toArray()});
  }
  expandBreakStatement(term_737) {
    return new Term("BreakStatement", {label: term_737.label ? term_737.label.val() : null});
  }
  expandDoWhileStatement(term_738) {
    return new Term("DoWhileStatement", {body: this.expand(term_738.body), test: this.expand(term_738.test)});
  }
  expandWithStatement(term_739) {
    return new Term("WithStatement", {body: this.expand(term_739.body), object: this.expand(term_739.object)});
  }
  expandDebuggerStatement(term_740) {
    return term_740;
  }
  expandContinueStatement(term_741) {
    return new Term("ContinueStatement", {label: term_741.label ? term_741.label.val() : null});
  }
  expandSwitchStatementWithDefault(term_742) {
    return new Term("SwitchStatementWithDefault", {discriminant: this.expand(term_742.discriminant), preDefaultCases: term_742.preDefaultCases.map(c_743 => this.expand(c_743)).toArray(), defaultCase: this.expand(term_742.defaultCase), postDefaultCases: term_742.postDefaultCases.map(c_744 => this.expand(c_744)).toArray()});
  }
  expandComputedMemberExpression(term_745) {
    return new Term("ComputedMemberExpression", {object: this.expand(term_745.object), expression: this.expand(term_745.expression)});
  }
  expandSwitchStatement(term_746) {
    return new Term("SwitchStatement", {discriminant: this.expand(term_746.discriminant), cases: term_746.cases.map(c_747 => this.expand(c_747)).toArray()});
  }
  expandFormalParameters(term_748) {
    let rest_749 = term_748.rest == null ? null : this.expand(term_748.rest);
    return new Term("FormalParameters", {items: term_748.items.map(i_750 => this.expand(i_750)), rest: rest_749});
  }
  expandArrowExpression(term_751) {
    return this.doFunctionExpansion(term_751, "ArrowExpression");
  }
  expandSwitchDefault(term_752) {
    return new Term("SwitchDefault", {consequent: term_752.consequent.map(c_753 => this.expand(c_753)).toArray()});
  }
  expandSwitchCase(term_754) {
    return new Term("SwitchCase", {test: this.expand(term_754.test), consequent: term_754.consequent.map(c_755 => this.expand(c_755)).toArray()});
  }
  expandForInStatement(term_756) {
    return new Term("ForInStatement", {left: this.expand(term_756.left), right: this.expand(term_756.right), body: this.expand(term_756.body)});
  }
  expandTryCatchStatement(term_757) {
    return new Term("TryCatchStatement", {body: this.expand(term_757.body), catchClause: this.expand(term_757.catchClause)});
  }
  expandTryFinallyStatement(term_758) {
    let catchClause_759 = term_758.catchClause == null ? null : this.expand(term_758.catchClause);
    return new Term("TryFinallyStatement", {body: this.expand(term_758.body), catchClause: catchClause_759, finalizer: this.expand(term_758.finalizer)});
  }
  expandCatchClause(term_760) {
    return new Term("CatchClause", {binding: this.expand(term_760.binding), body: this.expand(term_760.body)});
  }
  expandThrowStatement(term_761) {
    return new Term("ThrowStatement", {expression: this.expand(term_761.expression)});
  }
  expandForOfStatement(term_762) {
    return new Term("ForOfStatement", {left: this.expand(term_762.left), right: this.expand(term_762.right), body: this.expand(term_762.body)});
  }
  expandBindingIdentifier(term_763) {
    return term_763;
  }
  expandBindingPropertyIdentifier(term_764) {
    return term_764;
  }
  expandBindingPropertyProperty(term_765) {
    return new Term("BindingPropertyProperty", {name: this.expand(term_765.name), binding: this.expand(term_765.binding)});
  }
  expandComputedPropertyName(term_766) {
    return new Term("ComputedPropertyName", {expression: this.expand(term_766.expression)});
  }
  expandObjectBinding(term_767) {
    return new Term("ObjectBinding", {properties: term_767.properties.map(t_768 => this.expand(t_768)).toArray()});
  }
  expandArrayBinding(term_769) {
    let restElement_770 = term_769.restElement == null ? null : this.expand(term_769.restElement);
    return new Term("ArrayBinding", {elements: term_769.elements.map(t_771 => t_771 == null ? null : this.expand(t_771)).toArray(), restElement: restElement_770});
  }
  expandBindingWithDefault(term_772) {
    return new Term("BindingWithDefault", {binding: this.expand(term_772.binding), init: this.expand(term_772.init)});
  }
  expandShorthandProperty(term_773) {
    return new Term("DataProperty", {name: new Term("StaticPropertyName", {value: term_773.name}), expression: new Term("IdentifierExpression", {name: term_773.name})});
  }
  expandForStatement(term_774) {
    let init_775 = term_774.init == null ? null : this.expand(term_774.init);
    let test_776 = term_774.test == null ? null : this.expand(term_774.test);
    let update_777 = term_774.update == null ? null : this.expand(term_774.update);
    let body_778 = this.expand(term_774.body);
    return new Term("ForStatement", {init: init_775, test: test_776, update: update_777, body: body_778});
  }
  expandYieldExpression(term_779) {
    let expr_780 = term_779.expression == null ? null : this.expand(term_779.expression);
    return new Term("YieldExpression", {expression: expr_780});
  }
  expandYieldGeneratorExpression(term_781) {
    let expr_782 = term_781.expression == null ? null : this.expand(term_781.expression);
    return new Term("YieldGeneratorExpression", {expression: expr_782});
  }
  expandWhileStatement(term_783) {
    return new Term("WhileStatement", {test: this.expand(term_783.test), body: this.expand(term_783.body)});
  }
  expandIfStatement(term_784) {
    let consequent_785 = term_784.consequent == null ? null : this.expand(term_784.consequent);
    let alternate_786 = term_784.alternate == null ? null : this.expand(term_784.alternate);
    return new Term("IfStatement", {test: this.expand(term_784.test), consequent: consequent_785, alternate: alternate_786});
  }
  expandBlockStatement(term_787) {
    return new Term("BlockStatement", {block: this.expand(term_787.block)});
  }
  expandBlock(term_788) {
    return new Term("Block", {statements: term_788.statements.map(s_789 => this.expand(s_789)).toArray()});
  }
  expandVariableDeclarationStatement(term_790) {
    return new Term("VariableDeclarationStatement", {declaration: this.expand(term_790.declaration)});
  }
  expandReturnStatement(term_791) {
    if (term_791.expression == null) {
      return term_791;
    }
    return new Term("ReturnStatement", {expression: this.expand(term_791.expression)});
  }
  expandClassDeclaration(term_792) {
    return new Term("ClassDeclaration", {name: term_792.name == null ? null : this.expand(term_792.name), super: term_792.super == null ? null : this.expand(term_792.super), elements: term_792.elements.map(el_793 => this.expand(el_793)).toArray()});
  }
  expandClassExpression(term_794) {
    return new Term("ClassExpression", {name: term_794.name == null ? null : this.expand(term_794.name), super: term_794.super == null ? null : this.expand(term_794.super), elements: term_794.elements.map(el_795 => this.expand(el_795)).toArray()});
  }
  expandClassElement(term_796) {
    return new Term("ClassElement", {isStatic: term_796.isStatic, method: this.expand(term_796.method)});
  }
  expandThisExpression(term_797) {
    return term_797;
  }
  expandSyntaxTemplate(term_798) {
    let expander_799 = new Expander(this.context);
    let r_800 = processTemplate(term_798.template.inner());
    let str_801 = Syntax.fromString(serializer.write(r_800.template));
    let callee_802 = new Term("IdentifierExpression", {name: Syntax.fromIdentifier("syntaxTemplate")});
    let expandedInterps_803 = r_800.interp.map(i_805 => {
      let enf_806 = new Enforester(i_805, List(), this.context);
      return this.expand(enf_806.enforest("expression"));
    });
    let args_804 = List.of(new Term("LiteralStringExpression", {value: str_801})).concat(expandedInterps_803);
    return new Term("CallExpression", {callee: callee_802, arguments: args_804});
  }
  expandSyntaxQuote(term_807) {
    let str_808 = new Term("LiteralStringExpression", {value: Syntax.fromString(serializer.write(term_807.name))});
    return new Term("TemplateExpression", {tag: term_807.template.tag, elements: term_807.template.elements.push(str_808).push(new Term("TemplateElement", {rawValue: ""})).toArray()});
  }
  expandStaticMemberExpression(term_809) {
    return new Term("StaticMemberExpression", {object: this.expand(term_809.object), property: term_809.property});
  }
  expandArrayExpression(term_810) {
    return new Term("ArrayExpression", {elements: term_810.elements.map(t_811 => t_811 == null ? t_811 : this.expand(t_811))});
  }
  expandImport(term_812) {
    return term_812;
  }
  expandImportNamespace(term_813) {
    return term_813;
  }
  expandExport(term_814) {
    return new Term("Export", {declaration: this.expand(term_814.declaration)});
  }
  expandExportDefault(term_815) {
    return new Term("ExportDefault", {body: this.expand(term_815.body)});
  }
  expandExportFrom(term_816) {
    return term_816;
  }
  expandExportAllFrom(term_817) {
    return term_817;
  }
  expandExportSpecifier(term_818) {
    return term_818;
  }
  expandStaticPropertyName(term_819) {
    return term_819;
  }
  expandDataProperty(term_820) {
    return new Term("DataProperty", {name: this.expand(term_820.name), expression: this.expand(term_820.expression)});
  }
  expandObjectExpression(term_821) {
    return new Term("ObjectExpression", {properties: term_821.properties.map(t_822 => this.expand(t_822))});
  }
  expandVariableDeclarator(term_823) {
    let init_824 = term_823.init == null ? null : this.expand(term_823.init);
    return new Term("VariableDeclarator", {binding: this.expand(term_823.binding), init: init_824});
  }
  expandVariableDeclaration(term_825) {
    return new Term("VariableDeclaration", {kind: term_825.kind, declarators: term_825.declarators.map(d_826 => this.expand(d_826))});
  }
  expandParenthesizedExpression(term_827) {
    if (term_827.inner.size === 0) {
      throw new Error("unexpected end of input");
    }
    let enf_828 = new Enforester(term_827.inner, List(), this.context);
    let lookahead_829 = enf_828.peek();
    let t_830 = enf_828.enforestExpression();
    if (t_830 == null || enf_828.rest.size > 0) {
      throw enf_828.createError(lookahead_829, "unexpected syntax");
    }
    return this.expand(t_830);
  }
  expandUnaryExpression(term_831) {
    return new Term("UnaryExpression", {operator: term_831.operator, operand: this.expand(term_831.operand)});
  }
  expandUpdateExpression(term_832) {
    return new Term("UpdateExpression", {isPrefix: term_832.isPrefix, operator: term_832.operator, operand: this.expand(term_832.operand)});
  }
  expandBinaryExpression(term_833) {
    let left_834 = this.expand(term_833.left);
    let right_835 = this.expand(term_833.right);
    return new Term("BinaryExpression", {left: left_834, operator: term_833.operator, right: right_835});
  }
  expandConditionalExpression(term_836) {
    return new Term("ConditionalExpression", {test: this.expand(term_836.test), consequent: this.expand(term_836.consequent), alternate: this.expand(term_836.alternate)});
  }
  expandNewTargetExpression(term_837) {
    return term_837;
  }
  expandNewExpression(term_838) {
    let callee_839 = this.expand(term_838.callee);
    let enf_840 = new Enforester(term_838.arguments, List(), this.context);
    let args_841 = enf_840.enforestArgumentList().map(arg_842 => this.expand(arg_842));
    return new Term("NewExpression", {callee: callee_839, arguments: args_841.toArray()});
  }
  expandSuper(term_843) {
    return term_843;
  }
  expandCallExpression(term_844) {
    let callee_845 = this.expand(term_844.callee);
    let enf_846 = new Enforester(term_844.arguments, List(), this.context);
    let args_847 = enf_846.enforestArgumentList().map(arg_848 => this.expand(arg_848));
    return new Term("CallExpression", {callee: callee_845, arguments: args_847});
  }
  expandSpreadElement(term_849) {
    return new Term("SpreadElement", {expression: this.expand(term_849.expression)});
  }
  expandExpressionStatement(term_850) {
    let child_851 = this.expand(term_850.expression);
    return new Term("ExpressionStatement", {expression: child_851});
  }
  expandLabeledStatement(term_852) {
    return new Term("LabeledStatement", {label: term_852.label.val(), body: this.expand(term_852.body)});
  }
  doFunctionExpansion(term_853, type_854) {
    let scope_855 = freshScope("fun");
    let red_856 = new ApplyScopeInParamsReducer(scope_855, this.context);
    let params_857;
    if (type_854 !== "Getter" && type_854 !== "Setter") {
      params_857 = red_856.transform(term_853.params);
      params_857 = this.expand(params_857);
    }
    this.context.currentScope.push(scope_855);
    let expander_858 = new Expander(this.context);
    let markedBody_859, bodyTerm_860;
    if (term_853.body instanceof Term) {
      bodyTerm_860 = this.expand(term_853.body.addScope(scope_855, this.context.bindings));
    } else {
      markedBody_859 = term_853.body.map(b_861 => b_861.addScope(scope_855, this.context.bindings));
      bodyTerm_860 = new Term("FunctionBody", {directives: List(), statements: expander_858.expand(markedBody_859)});
    }
    this.context.currentScope.pop();
    if (type_854 === "Getter") {
      return new Term(type_854, {name: this.expand(term_853.name), body: bodyTerm_860});
    } else if (type_854 === "Setter") {
      return new Term(type_854, {name: this.expand(term_853.name), param: term_853.param, body: bodyTerm_860});
    }
    return new Term(type_854, {name: term_853.name, isGenerator: term_853.isGenerator, params: params_857, body: bodyTerm_860});
  }
  expandMethod(term_862) {
    return this.doFunctionExpansion(term_862, "Method");
  }
  expandSetter(term_863) {
    return this.doFunctionExpansion(term_863, "Setter");
  }
  expandGetter(term_864) {
    return this.doFunctionExpansion(term_864, "Getter");
  }
  expandFunctionDeclaration(term_865) {
    return this.doFunctionExpansion(term_865, "FunctionDeclaration");
  }
  expandFunctionExpression(term_866) {
    return this.doFunctionExpansion(term_866, "FunctionExpression");
  }
  expandCompoundAssignmentExpression(term_867) {
    return new Term("CompoundAssignmentExpression", {binding: this.expand(term_867.binding), operator: term_867.operator, expression: this.expand(term_867.expression)});
  }
  expandAssignmentExpression(term_868) {
    return new Term("AssignmentExpression", {binding: this.expand(term_868.binding), expression: this.expand(term_868.expression)});
  }
  expandEmptyStatement(term_869) {
    return term_869;
  }
  expandLiteralBooleanExpression(term_870) {
    return term_870;
  }
  expandLiteralNumericExpression(term_871) {
    return term_871;
  }
  expandLiteralInfinityExpression(term_872) {
    return term_872;
  }
  expandIdentifierExpression(term_873) {
    let trans_874 = this.context.env.get(term_873.name.resolve());
    if (trans_874) {
      return new Term("IdentifierExpression", {name: trans_874.id});
    }
    return term_873;
  }
  expandLiteralNullExpression(term_875) {
    return term_875;
  }
  expandLiteralStringExpression(term_876) {
    return term_876;
  }
  expandLiteralRegExpExpression(term_877) {
    return term_877;
  }
}
